import React from "react";
import {
  TextField,
  IconButton,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const EnumberHeader = ({ onSearch, loading }) => {
  const handleSearchChange = (event) => {
    onSearch(event.target.value);
  };

  return (
    <Stack
      sx={{
        position: "static",
        height: "450px",
        backgroundColor: "#00171f",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Stack
        spacing={2}
        sx={{
          width: { xs: "100%", sm: "80%", md: "60%", lg: "40%" },
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            textAlign: "center",
          }}
        >
          Enumber Halal Check
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            textAlign: "center",
          }}
        >
          Enter the Enumber you want to check
        </Typography>
        <TextField
          placeholder={"Enter Enumber..."}
          onChange={handleSearchChange}
          fullWidth
          disabled={loading}
          sx={{
            input: {
              color: "#fff",
              fontFamily: "Poppins, sans-serif",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#fff",
              },
              "&:hover fieldset": {
                borderColor: "#fff",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#fff",
              },
              backgroundColor: "transparent",
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#fff",
              opacity: 1,
            },
          }}
          InputProps={{
            startAdornment: loading ? (
              <Typography
                variant="subtitle1"
                sx={{
                  color: "#fff",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Loading...
              </Typography>
            ) : (
              ""
            ),
            endAdornment: loading ? (
              <CircularProgress size={15} style={{ color: "#fff" }} />
            ) : (
              <IconButton
                size="small"
                disabled={loading}
                sx={{ color: "#fff", fontFamily: "Poppins, sans-serif" }}
              >
                <SearchIcon />
              </IconButton>
            ),
            sx: {
              color: "#fff",
              border: "1px solid #fff",
              borderRadius: "4px",
              fontFamily: "Poppins, sans-serif",
              "&::placeholder": {
                color: "#fff",
              },
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default EnumberHeader;
